import type { SVGProps } from 'react'
const SvgMECRevoke = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.3333 15.1868L11.5625 16.9368L10.3958 15.7702L12.1458 13.9993L10.3958 12.2285L11.5625 11.0618L13.3333 12.8118L15.1042 11.0618L16.2708 12.2285L14.5208 13.9993L16.2708 15.7702L15.1042 16.9368L13.3333 15.1868ZM2.5 17.3327C1.80556 17.3327 1.21528 17.0896 0.729167 16.6035C0.243056 16.1174 0 15.5271 0 14.8327V12.3327H2.5V0.666016H15V9.31185C14.7361 9.21463 14.4653 9.14171 14.1875 9.0931C13.9097 9.04449 13.625 9.02018 13.3333 9.02018V2.33268H4.16667V12.3327H8.625C8.52778 12.5966 8.45486 12.8674 8.40625 13.1452C8.35764 13.423 8.33333 13.7077 8.33333 13.9993H1.66667V14.8327C1.66667 15.0688 1.74653 15.2667 1.90625 15.4264C2.06597 15.5862 2.26389 15.666 2.5 15.666H8.625C8.73611 15.9855 8.875 16.2841 9.04167 16.5618C9.20833 16.8396 9.40278 17.0966 9.625 17.3327H2.5ZM5 6.49935V4.83268H12.5V6.49935H5ZM5 8.99935V7.33268H12.5V8.99935H5Z"
      fill="#5E5E5E"
    />
  </svg>
)
export default SvgMECRevoke
